import StdTaskIcon from "../../../../../assets/icons/Standard.svg";
import MsWordIcon from "../../../../../assets/icons/Word.svg";
import MSExcelIcon from "../../../../../assets/icons/Excel.svg";
import MSPowerpointIcon from "../../../../../assets/icons/Powerpoint.svg";
import PriorityNew from "../common-components/priority-new";
import { TaskActions } from "../common-components/task-actions";
import { FluentBadge } from "../../../../../components/FluentUI/Fluent-Badge";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import StatusNew from "../common-components/status-new";
import TaskGridViewMembers from "../common-components/task-grid-view-members";
import { FluentTooltip } from "../../../../../components/FluentUI/Fluent-Tooltip";
import {
  DateFormatBasedOnDepartment,
  DateStringFormatBasedOnDepartment,
} from "../../../../../util/time-helpers";
import PriorityFluentNew from "../../../../../components/priority/priority-fluent-new";

const hideTaskListAlert = window["APP_SETTINGS"].HIDE_TASK_LIST_ALERT;
const actionableAllowed = hideTaskListAlert !== "TRUE" && hideTaskListAlert !== null;

export const initialDataState = {
  sort: [],
  take: 25,
  skip: 0,
};

export const priorityOrder = ["Low", "Medium", "High", "Urgent"];

export const CustomPriority = (a, b, dir) => {
  const newPriorityOrder =
    dir === "asc" ? [...priorityOrder] : [...priorityOrder].reverse();

  const aIndex = newPriorityOrder.indexOf(a.Priority);
  const bIndex = newPriorityOrder.indexOf(b.Priority);

  if (aIndex < bIndex) {
    return -1;
  } else if (aIndex > bIndex) {
    return 1;
  } else {
    return 0;
  }
};

const MapTaskObject = (taskToBekModified, dataTimeFormat) => {
  const { task } = taskToBekModified;

  let parsedData = { ...JSON.parse(task) };

  Object.entries(parsedData).forEach(([key, field]) => {
    if (key === "Due") {
      parsedData[key] = DateFormatBasedOnDepartment(
        parsedData["SearchableDue"],
        dataTimeFormat
      );
    }
  });

  return parsedData;
};

export const ModifyTaskData = (task, dataTimeFormat) => {
  let modifiedTask = task.map((task) => MapTaskObject(task, dataTimeFormat));
  return modifiedTask;
};

export const CustomCell = (column, props, labels) => {
  switch (column) {
    case "IsActionable":
      return;
    case "Type":
      return CustomTypeCell(props.dataItem);
    case "Priority":
      return CustomPriorityCell(props.dataItem);
    case "Status":
      return CustomStatusCell(props.dataItem);
    case "LastActivity":
      return CustomLastActivityCell(props.dataItem, labels);
    case "Members":
      return CustomMembersCell(props.dataItem);
    case "Due":
      return CustomDueCell(props.dataItem);
    default:
      return (
        <FluentTooltip
          target={<td className="k-table-td">{props.dataItem[column]}</td>}
          text={props.dataItem[column]}
        ></FluentTooltip>
      );
  }
};

export const CustomTypeCell = (dataItem) => {
  let icon = { image: "", title: "" };
  switch (dataItem?.Document?.DocumentTypeId) {
    case 0:
      icon = { image: StdTaskIcon, title: "Standard Task" };
      break;
    case 1:
      icon = { image: MsWordIcon, title: "MS Office Task - Word" };
      break;
    case 2:
      icon = { image: MSExcelIcon, title: "MS Office Task - Excel" };
      break;
    case 3:
      icon = {
        image: MSPowerpointIcon,
        title: "MS Office Task - PowerPoint",
      };
      break;
    default:
      icon = { image: StdTaskIcon, title: "Standard Task" };
      break;
  }

  return (
    <td className="k-table-td td-type">
      <div className={`${dataItem.IsActionable && actionableAllowed ? "actionable" : "type"} no-pointer width-fit-content`}>
        {dataItem.IsActionable &&
          (hideTaskListAlert === null ||
            actionableAllowed) && (
            <FluentTooltip
              target={
                <p>
                  <FluentBadge
                    shape="rounded"
                    appearance="tint"
                    size="medium"
                    color="danger"
                    icon={
                      <FluentUiIcon
                        name={"ImportantFilled"}
                        color={"#C43501"}
                        size={12}
                      />
                    }
                  ></FluentBadge>
                </p>
              }
              text={"This task requires your action."}
            ></FluentTooltip>
          )}
        <FluentTooltip
          target={<img src={icon.image} alt={icon.title} />}
          text={icon.title}
        ></FluentTooltip>
      </div>
    </td>
  );
};

export const CustomPriorityCell = (dataItem) => {
  return (
    <FluentTooltip
      target={
        <td className="k-table-td td-priority">
          <PriorityFluentNew priority={dataItem?.Priority} /> 
        </td>
      }
      text={dataItem?.Priority}
    ></FluentTooltip>
  );
};

export const CustomStatusCell = (dataItem) => {
  return (
    <td className="k-table-td td-status">
      <StatusNew status={dataItem.Status} />
    </td>
  );
};

export const CustomLastActivityCell = (dataItem, labels) => {
  let lastActivity = dataItem?.LastActivity ?? "";
    if (labels) {
      if (labels.ProjectSingular) {
        lastActivity = lastActivity.replaceAll("Project", labels.ProjectSingular);
      }
      if (labels.TaskSingular) {
        lastActivity = lastActivity.replaceAll("Task", labels.TaskSingular);
      }
      if (labels.FormSingular) {
        lastActivity = lastActivity.replaceAll("Form", labels.FormSingular);
      }
    }

  return (
    <FluentTooltip
      target={
        <td className="k-table-td td-activity">
          {dataItem?.LastActivity && (
            <FluentBadge
              className="no-pointer width-fit-content"
              shape="rounded"
              appearance="tint"
              size="extra-large"
              text={lastActivity}
            ></FluentBadge>
          )}
        </td>
      }
      text={`${lastActivity} - ${dataItem?.LastActivityCreated}`}
    ></FluentTooltip>
  );
};

export const CustomMembersCell = (dataItem) => {
  return (
    <td className="k-table-td td-members">
      <TaskGridViewMembers
        taskCreator={dataItem.CreatedBy}
        dataItemType={dataItem.TaskTypeId}
        UserID={dataItem.CreatedById}
        members={dataItem.Members}
        groups={dataItem.Groups}
      ></TaskGridViewMembers>
    </td>
  );
};

export const CustomDueCell = (dataItem) => {
  let date = new Date(dataItem?.Due);
  return (
    <FluentTooltip
      target={
        <td className="k-table-td">
          {!isNaN(date) ? dataItem?.SearchableDue : ""}
        </td>
      }
      text={
        !isNaN(date) ? `${dataItem?.Start} - ${dataItem?.SearchableDue}` : ""
      }
    ></FluentTooltip>
  );
};

export const CustomActionsCell = ({ dataItem }, GetTasks) => {
  return (
    <td className="k-table-td td-actions">
      <TaskActions
        taskId={dataItem.Id}
        task={dataItem}
        refreshTasks={GetTasks}
      ></TaskActions>
    </td>
  );
};

export const HeaderCustomCell = (props, user) => {
  return (
    props.tdProps && (
      <td {...props.tdProps}>
        {props.children && (
          <p className="k-reset">
            {props.children.props.children[0]}
            {props.dataItem.field === "Due"
              ? DateStringFormatBasedOnDepartment(
                  props.dataItem.value,
                  user?.currentUser?.department?.DateFormatID
                )
              : props.dataItem.value}
          </p>
        )}
      </td>
    )
  );
};

const MEDIA_SIZES = {
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
  DEFAULT: "DEFAULT",
};

export const getCurrentMediaSize = () => {
  const width = window.innerWidth;
  if (width >= 1900)  return MEDIA_SIZES.LARGE;
  if (width >= 1130 && width <= 1300) return MEDIA_SIZES.MEDIUM;
  if (width <= 1130) return MEDIA_SIZES.SMALL;
  return MEDIA_SIZES.DEFAULT;
};

export const getColumnWidthForStaticTaskList = (columnName, mediaSize) => {
  if (!columnName) return "auto";
  const widths = {
    SMALL: {
      Type: "auto",
      Project: "auto",
      Name: "auto",
      default: "auto",
    },
    MEDIUM: {
      Type: "100px",
      Project: "180px",
      Name: "180px",
      default: "auto",
    },
    LARGE: {
      Type: "100px",
      Project: "auto",
      Name: "auto",
      default: "auto",
    },
    DEFAULT: {
      Type: "100px",
      Project: "220px",
      Name: "220px",
      default: "auto",
    },
  };

  const sizeWidths = widths[mediaSize] || widths.DEFAULT;
  return sizeWidths[columnName] ?? sizeWidths.default ?? "auto";
};

